export const delay = t => new Promise(resolve => setTimeout(resolve, t));